module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n    viewBox=\"0 0 36 36\">\r\n  <path d=\"M18,6A12,12,0,1,0,30,18,12,12,0,0,0,18,6Zm0,22A10,10,0,1,1,28,18,10,10,0,0,1,18,28Z\"></path>\r\n  <path d=\"M18,21.32a1.3,1.3,0,0,0,1.3-1.3V14a1.3,1.3,0,1,0-2.6,0v6A1.3,1.3,0,0,0,18,21.32Z\"></path>\r\n  <circle cx=\"17.95\" cy=\"24.27\" r=\"1.5\"></circle>\r\n</svg>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-alert/icons/error.html
// module id = 292
// module chunks = 0